// @ts-strict-ignore
/* eslint-disable camelcase */
import classNames from 'classnames'
import React from 'react'

interface LabelProps {
  children: React.ReactNode
  htmlFor?: string
  className?: string
}

interface FieldProps {
  children: React.ReactNode
  style?: object
  stack?: boolean
  className?: string
}

export const Label = ({ children, htmlFor, className }: LabelProps) => {
  return (
    <label htmlFor={htmlFor} className={className}>
      {children}
    </label>
  )
}

export const FieldGroup = ({ children, type = 'default', stack = false }) => {
  return (
    <div
      className={classNames('FieldGroup', {
        FieldGroup__stack: stack,
        'FieldGroup--first-small': type === 'first-small',
      })}
    >
      {children}
    </div>
  )
}

const Field = ({ children, style, stack = false, className }: FieldProps) => {
  return (
    <div style={style} className={classNames('Field', { Field__stack: stack }, className)}>
      {children}
    </div>
  )
}

export default Field
